

export const setCell = (worksheet, cellAddress, value, options = {}) => {
    const cell = worksheet.getCell(cellAddress);
    cell.value = value;
  
    if (options.dataType === 'date') {
      cell.value = new Date(value); 
      cell.numFmt = 'dd/mm/yyyy'; 
    } else if(options.dataType === 'percentual') {
        cell.numFmt = value % 1 !== 0 ? '0.0%' : '0%';
        cell.value = value / 100; 
    } else if(options.dataType === 'times') {
      cell.value = value ? value / 86400 : null;
      // Formatta la cella come "mm:ss,000"
      cell.numFmt = 'mm:ss.000';
    
    } else if(options.dataType === 'dateTime') {

      const date = new Date(value);
      const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      cell.value = adjustedDate;
      cell.numFmt = 'dd/mm/yyyy h:mm';

    } else if(options.dataType === 'dateTime2') {

        cell.value = new Date(value); 
        cell.numFmt = 'dd/mm/yyyy h:mm'; 
    } else {
      cell.value = value;
    }
  
    // Font
    if (options.font || options.color) {
      cell.font = {
        ...cell.font,
        ...options.font,
        ...(options.color ? { color: { argb: options.color } } : {}),
      };
    }
  
    // Filling
    if (options.fill || options.fgColor) {
      cell.fill = {
        ...cell.fill,
        ...options.fill,
        ...(options.fgColor
          ? { type: 'pattern', pattern: 'solid', fgColor: { argb: options.fgColor } }
          : {}),
      };
    }
  
    // Alignment
    if (options.alignment || options.align || options.valign || options.wrapText) {
      cell.alignment = {
        ...cell.alignment,
        ...options.alignment,
        ...(options.align ? { horizontal: options.align } : {}),
        ...(options.valign ? { vertical: options.valign } : {}),
        ...(options.wrapText ? { wrapText: true } : {}),
      };
    }

    
  
    // borders

    cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: options.border ?? 'thin' },
    }
}



export const coordinateX = (number) => {
    let columnName = '';
    while (number >= 0) {
        columnName = String.fromCharCode((number % 26) + 65) + columnName;
        number = Math.floor(number / 26) - 1;
    }
    return columnName;
}